import _defineProperty from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { AddressZero } from '@ethersproject/constants';
import { createAction, createReducer } from '@reduxjs/toolkit';
import { useWeb3React } from '@web3-react/core';
import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';
import { useRouter } from 'next/router';
import { createContext, useCallback, useContext, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWETH, useWETHDepositCallback, useWETHWithdrawCallback } from "../../hooks";
import { useTokenPrice } from "../../hooks/useTokenPrice";
import useUpdaterByBlock from "../../hooks/useUpdaterByBlock";
import { useFeeData, useModalOpened, useModalSwitch } from "../../state/application/hooks";
import { ApplicationModal } from "../../state/application/reducer";
import { useNativeTokenBalance, useTokenBalance } from "../../state/wallet/hooks";
import { gasSpeedup } from "../../utils/gasSpeedup";
import { message } from "../Message";
import iconETH from "../../assets/images/icon-eth.png";
import iconWETH from "../../assets/images/icon-weth.png";
export var WETHWrapDirection;

(function (WETHWrapDirection) {
  WETHWrapDirection["Wrap"] = "ETH => WETH";
  WETHWrapDirection["Unwrap"] = "WETH => ETH";
})(WETHWrapDirection || (WETHWrapDirection = {}));

var initialState = {
  direction: WETHWrapDirection.Wrap,
  value: '0',
  receipt: null
};
export var toggleDirection = createAction('weth/toggleDirection');
export var updateValue = createAction('weth/updateValue');
export var updateReceipt = createAction('weth/updateReceipt');
var wethReducer = createReducer(initialState, function (builder) {
  return builder.addCase(toggleDirection, function (state) {
    state.direction = state.direction === WETHWrapDirection.Unwrap ? WETHWrapDirection.Wrap : WETHWrapDirection.Unwrap;
  }).addCase(updateValue, function (state, _ref) {
    var payload = _ref.payload;
    state.value = payload;
  }).addCase(updateReceipt, function (state, _ref2) {
    var payload = _ref2.payload;
    state.receipt = payload;
  });
});
export var WETHContext = /*#__PURE__*/createContext(null);
export var WETHProvider = function WETHProvider(_ref3) {
  var children = _ref3.children;

  var _useReducer = useReducer(wethReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  useNetworkChangeNotice();
  useWETHVisible();
  return __jsx(WETHContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children);
}; // TODO: 把内部逻辑移到 Provider 里，避免多次执行

export var useWETHContext = function useWETHContext() {
  var context = useContext(WETHContext);

  if (context === undefined) {
    throw new Error('useWETHContext must be called in WETHProvider');
  }

  var WETHContract = useWETH();
  var state = context.state,
      dispatch = context.dispatch;
  var direction = state.direction,
      value = state.value;
  var isWrap = direction === WETHWrapDirection.Wrap;
  var WETH = {
    address: WETHContract === null || WETHContract === void 0 ? void 0 : WETHContract.address,
    decimals: 18,
    symbol: 'WETH',
    name: 'WETH',
    logo: iconWETH.src
  };
  var ETH = {
    address: AddressZero,
    decimals: 18,
    symbol: 'ETH',
    name: 'ETH',
    logo: iconETH.src
  };
  var inputToken = isWrap ? ETH : WETH;
  var outputToken = isWrap ? WETH : ETH;
  var ethPrice = useTokenPrice(AddressZero);

  var _useWeb3React = useWeb3React(),
      provider = _useWeb3React.provider,
      chainId = _useWeb3React.chainId,
      account = _useWeb3React.account;

  var _useWETHDepositCallba = useWETHDepositCallback(),
      depositGasEstimate = _useWETHDepositCallba.estimateGas;

  var _useWETHWithdrawCallb = useWETHWithdrawCallback(),
      withdrawGasEstimate = _useWETHWithdrawCallb.estimateGas;

  var _useState = useState(ethers.BigNumber.from(0)),
      gas = _useState[0],
      setGas = _useState[1];

  var estimateGas = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var v, gasLimit;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (value) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", setGas(ethers.BigNumber.from(0)));

          case 2:
            v = ethers.utils.parseEther(value);
            _context.prev = 3;

            if (!isWrap) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return depositGasEstimate(v);

          case 7:
            _context.t0 = _context.sent;
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return withdrawGasEstimate(v);

          case 12:
            _context.t0 = _context.sent;

          case 13:
            gasLimit = _context.t0;
            setGas(gasSpeedup(gasLimit));
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](3);
            console.error('estimate error', _context.t1);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  })), [value, depositGasEstimate, withdrawGasEstimate]);
  useUpdaterByBlock(estimateGas, 3);
  var feeData = useFeeData();
  var gasInfo = useMemo(function () {
    var price = ethers.BigNumber.from((feeData === null || feeData === void 0 ? void 0 : feeData.gasPrice) || 0);
    var ether = new BigNumber(ethers.utils.formatEther(price.mul(gas)));
    return {
      ether: ether.sd(4).toFormat(),
      useValue: ether.times(ethPrice).sd(4).toFormat(1)
    };
  }, [feeData, ethPrice, gas]);
  var inputTokenBalance = useTokenBalance(account, inputToken);
  var ethBalance = useNativeTokenBalance();
  var balance = isWrap ? ethBalance : inputTokenBalance;
  return {
    state: _objectSpread(_objectSpread({}, state), {}, {
      inputToken: inputToken,
      outputToken: outputToken,
      isWrap: isWrap,
      gasInfo: gasInfo,
      balance: balance
    }),
    dispatch: dispatch
  };
};

var useNetworkChangeNotice = function useNetworkChangeNotice() {
  var _useWeb3React2 = useWeb3React(),
      chainId = _useWeb3React2.chainId;

  var isOpen = useModalOpened(ApplicationModal.WETH_PREVIEW);
  var chainIdRef = useRef();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    if (!chainIdRef.current) chainIdRef.current = chainId;

    if (chainIdRef.current !== chainId) {
      chainIdRef.current = chainId;
      isOpen && message.error(t('network_changed'));
    }
  }, [chainIdRef.current, chainId, isOpen]);
};

var useWETHVisible = function useWETHVisible() {
  var _useRouter = useRouter(),
      pathname = _useRouter.pathname;

  var switchWrap = useModalSwitch(ApplicationModal.WETH_WRAP);
  var switchResult = useModalSwitch(ApplicationModal.WETH_RESULT);
  var switchReview = useModalSwitch(ApplicationModal.WETH_PREVIEW);
  useEffect(function () {
    if (pathname === '/weth') {
      switchWrap(true);
    } else {
      switchWrap(false);
      switchReview(false);
      switchResult(false);
    }
  }, [pathname]);
};